import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Divider, Text } from '@chakra-ui/react';

import LoadingSpinner from '../../../../components/Spinner';
import { analyticsIds } from '../../../../constants/analyticsIds';
import { createErrorToast, createSuccessToast } from '../../../../redux/modules/app';
import { selectUser, updateUserBasicInfo } from '../../../../redux/modules/user';
import { removePhoneNumberFormat } from '../../../../utils/formatPhoneUtil';
import SaveButton from '../../components/SaveButton';
import TabPanelFooter from '../../components/TabPanelFooter';

import BasicInfoForm from './components/BasicInfo';
import ChangePasswordForm from './components/ChangePasswordForm';
import UserRoles from './components/UserRoles';

function ProfileTabPanel(props) {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async data => {
    setIsSubmitting(true);
    const phoneNumber = removePhoneNumberFormat(data.userPhone);
    const userData = { ...data, userPhone: phoneNumber };
    const response = await dispatch(updateUserBasicInfo(user.userId, userData));

    if (response.success) dispatch(createSuccessToast({ title: 'Profile updated successfully!' }));
    else {
      dispatch(createErrorToast({
        title: 'Uh oh, something went wrong.',
        description: 'Please try again or contact support.'
      }));
    }

    setIsSubmitting(false);
  };

  return (
    <Box {...props}>
      <Box px={5} py={4} w="100%">
        <Text fontWeight="medium" textAlign="left">Basic Information</Text>
        {user.userId || user.user_id
          ? <BasicInfoForm user={user} onSubmit={onSubmit} />
          : <LoadingSpinner />}
        <UserRoles user={user} />
      </Box>
      <Divider />
      <Box px={5} py={4} w="100%">
        <Text fontWeight="medium" textAlign="left">Change Password</Text>
        <ChangePasswordForm />
      </Box>
      <TabPanelFooter>
        <SaveButton
          dataAnalyticsId={analyticsIds.userSettings.profile.saveUserInfoButton}
          dusk={analyticsIds.userSettings.profile.saveUserInfoButton}
          formId="userInfo"
          isDisabled={isSubmitting}
        />
      </TabPanelFooter>
    </Box>
  );
};

export default ProfileTabPanel;
